export default __webpack_public_path__ + "images/half-location-person-in-circle.9ee895e5a649043f1cd8f163160857c7.png";